import { ReactElement } from 'react';

/**
 * Component for 404 page.
 * @returns - 404 page.
 */
function NoMatch(): ReactElement {
  return <div className="text-center text-white pt-20">Page Not found</div>;
}

export default NoMatch;
